import React, { useMemo } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import GridRow from './grid-row';
import { StringsMapping } from '../../common/strings';
import { BoldSyntax } from '../../common/util';

function ConversionTrackingGrid(props) {
  const {
    deps,
    metric,
    processedData,
    newI18n,
  } = props;

  const metricName = useMemo(
    () =>
      (metric ? deps.s$i18n.property('PerformanceMetric', metric) : ''),
    [deps.s$i18n, metric]
  );
  const emptyText = useMemo(
    () => newI18n.getString(StringsMapping.Empty_Data),
    [newI18n]
  );

  const renderGridRows = useMemo(() => (
    _.size(processedData) === 0 ?
      <div className="conversion-tracking-grid-empty">
        <BoldSyntax template={emptyText} />
      </div> :

      <div className="conversion-goals-grid">
        {processedData.map((currentRow, index) => (index < 4 ?
          <GridRow
            item={currentRow}
            metricName={metricName}
            index={index}
            {...props}
          /> : null))}
      </div>), [emptyText, metricName, processedData, props]);

  return (
    <div className="conversion-tracking-grid-container">
      {renderGridRows}
    </div>
  );
}

ConversionTrackingGrid.defaultProps = {
  emptyText: '',
};
ConversionTrackingGrid.propTypes = {
  deps: PropTypes.shape({
    s$i18n: PropTypes.shape({
      property: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
  metric: PropTypes.string.isRequired,
  processedData: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  emptyText: PropTypes.string,
};

export default ConversionTrackingGrid;
